import { SvgIconBase, } from "./Base";


export const CrossStroke = ({
	fill = "#AAACA7",
	scale = 1,
}: { fill?: string; scale?: number; }) => {
	return (
		<SvgIconBase width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Cross" scale={scale}>
			<title>Cross</title>
			<path
				d="M12 4L4 12M4 4L12 12"
				stroke={fill}
				strokeWidth="2.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</SvgIconBase>
	);
};

